import React from 'react';
import { X } from 'lucide-react';
import { ModalProps } from './Modal.types';
import { Button } from '../Button';

const sizeClasses: Record<ModalProps['size'], string> = {
  sm: 'max-w-sm',      // ~384px
  md: 'max-w-md',      // ~448px
  lg: 'max-w-lg'       // ~512px
};

export function Modal({ isOpen, title, children, onClose, size = 'md', className = '' }: ModalProps) {
  if (!isOpen) return null;

  const titleSizeClass = size === 'sm' ? 'text-sm' : size === 'md' ? 'text-lg' : 'text-xl';
  const headerPadding = size === 'sm' ? 'p-2' : 'p-3 sm:p-4';
  const bodyPadding = size === 'sm' ? 'p-2' : 'p-2 sm:p-4';
  const containerMargin = size === 'sm' ? 'mx-2' : 'mx-0 sm:mx-4';
  
  // Para size="sm", sempre altura automática; para outros, h-full em mobile
  const heightClass = size === 'sm' ? 'h-auto max-h-[85vh]' : 'h-full sm:h-auto';

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-[100]">
      <div className={`bg-navy-800 shadow-xl w-full ${heightClass} rounded-lg ${containerMargin} animate-fadeIn flex flex-col ${sizeClasses[size]} ${className}`.trim()}>
        {title && (
          <div className={`flex justify-between items-center ${headerPadding} border-b border-navy-700 shrink-0`}>
            <h2 className={`${titleSizeClass} font-semibold text-white`}>{title}</h2>
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className={size === 'sm' ? 'p-1' : 'p-2'}
            >
              <X className={size === 'sm' ? 'w-4 h-4' : 'w-5 h-5'} />
            </Button>
          </div>
        )}
        <div className={`${title ? bodyPadding : ''} flex-1 min-h-0 overflow-y-auto`.trim()}>
          {children}
        </div>
      </div>
    </div>
  );
}

